export const ActionTypes = {
  FETCH_ENERGY_GRID: 'services/dashboards/energy/fetch_energy_grid',
  SET_ENERGY_GRID: 'services/dashboards/energy/set_energy_grid',
  SET_LOADER_STATUS: 'services/dashboards/energy/set_loader_status',
};
const fetchEnergyGrid = ({ energyGridParams }) => ({
  energyGridParams,
  type: ActionTypes.FETCH_ENERGY_GRID,
});

const setEnergyGrid = ({ energyGrid }) => ({
  energyGrid,
  type: ActionTypes.SET_ENERGY_GRID,
});
const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

export default {
  fetchEnergyGrid,
  setEnergyGrid,
  setLoader,
};
